/* global process */
let orderAuditBase = window._env_.VUE_APP_ORDER_AUDIT_API_HOST

// 获取目标设定列表
export const getTargetSettingTable = params => {
  return axios.get(`${orderAuditBase}/admin/audit-project-range/query`, { params })
}

// 创建目标设定
export const createTargetSetting = params => {
  return axios.post(`${orderAuditBase}/admin/audit-project-range/create`, params)
}

// 获取目标值列表
export const getTargetValueTable = params => {
  return axios.get(`${orderAuditBase}/admin/intern-audit-daily-plan/query`, { params })
}

// 创建目标值
export const createTargetValue = params => {
  return axios.post(`${orderAuditBase}/admin/intern-audit-daily-plan/create`, params)
}

// 批量创建目标值
export const batchCreateTargetValue = params => {
  return axios.post(`${orderAuditBase}/admin/intern-audit-daily-plan/batch-create`, params)
}

// 更新目标值
export const updateTargetValue = params => {
  return axios.post(`${orderAuditBase}/admin/intern-audit-daily-plan/update/${params.id}`, params)
}
// 获取实习生详情：复用 audit-intern 中的实习生基础信息风格
export const getTargetInternUserDetail = params => {
  return axios.get(`${orderAuditBase}/admin/intern_user/${params.id}/base`, { params })
}

// KeyIn 异常工单反馈列表查询
export const getQueryKeyin = params => {
  return axios.get(`${orderAuditBase}/admin/review-task/query-keyin`, { params })
}




// WEBPACK FOOTER //
// ./src/views/order-review-target-management/order-review-assessment.api.js